import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  token: string;

  constructor(private http: HttpClient) {
    this.token = localStorage.getItem('token');
  }

  loggedIn() {
    return this.token != null;
  }

  logout(): Observable<string> {
    return this.http.post<any>(`${environment.url}/logout`, this.token);
  }

  redirectLogout() {
    localStorage.clear();
    window.location.href = `${environment.identity_url}/signout?redirect_uri=${environment.base_url}`;
  }
}
